export const AFT_ONLY_SUFFIX = "(AFT Org Only)";

export const LEADERSHIP_PAGE_TITLE = `Leadership Risk ${AFT_ONLY_SUFFIX}`;

export const LEADERSHIP_NAV_TITLE = `Leadership Dashboard ${AFT_ONLY_SUFFIX}`;

export const LEADERSHIP_OTHER_ORGS_MESSAGE =
    "The leadership dashboard currently covers the AFT org only. " +
    "Support for other orgs is coming soon.";

export const TEAMS_RECORD_URL = "https://permissions.amazon.com/";

export const DEPENDENCY_COVERAGE_HEADER = "Dependencies we cover";

export const DEPENDENCY_COVERAGE_MESSAGE =
    "Dependency Sentinel covers the library, runtime, and test dependencies declared " +
    "in a package's Config file. Anything else the Config file declares, such as build " +
    "tools, is not scanned and does not appear here.";

export const CR_CRITERIA_HEADER = "How code reviews are raised";

export const CR_CRITERIA_MESSAGE =
    "Dependency Sentinel raises code reviews for at-risk and upgrade-available " +
    "dependencies when the recommended version stays within the same major version. " +
    "High-risk dependencies have no recommended version to upgrade to, so no code " +
    "review is raised for them. Major version upgrades are not automated yet.";

export const DEFAULT_CR_LIMIT = 5;

export interface MonitorSchedule {
    readonly refreshes: string;
    readonly cadence: string;
    readonly detail: string;
}

export const MONITOR_SCHEDULES: readonly MonitorSchedule[] = [
    {
        refreshes: "Packages for your pipelines",
        cadence: "Weekly — Monday 00:00 UTC",
        detail:
            "Scans each onboarded pipeline and records the packages it builds, " +
            "along with version set and branch information.",
    },
    {
        refreshes: "Dependencies and their guidance",
        cadence: "Twice weekly — Monday and Thursday 02:00 UTC",
        detail:
            "Collects the dependencies of every known package and the current " +
            "vendor guidance for each one.",
    },
    {
        refreshes: "New code reviews",
        cadence: "Daily — 04:00 UTC",
        detail:
            "Raises code reviews for dependencies that have a recommended upgrade, " +
            "up to your team's code review limit.",
    },
    {
        refreshes: "Code review status",
        cadence: "Continuously, as reviews change",
        detail:
            "Updates a code review's state on this site shortly after it is raised, " +
            "merged, or closed. This is not on a schedule.",
    },
];

export const LEADERSHIP_MONITOR_SCHEDULE: MonitorSchedule = {
    refreshes: `Leadership dashboard data ${AFT_ONLY_SUFFIX}`,
    cadence: "Twice weekly — Monday and Thursday 03:00 UTC",
    detail:
        "Rolls up package and dependency risk for every manager in the org, " +
        "producing the summary totals, the packages table, and the CSV export.",
};
